import Detail from '../../../../components/Detail';
import { formatUSD } from '../../../../helpers/formats';
import useUserAccumulatedVoSpool from '../../../../hooks/web3/vault/useUserAccumulatedVoSpool';

const AcccumulatedVoSpool = () => {
    const { userAccumulatedVoSpool } = useUserAccumulatedVoSpool();

    return (
        <Detail
            title={
                <>
                    <span>Your Accumulated voSPOOL</span>
                    {/* <InfoPopUp>
                        <span className='bold'>voSPOOL</span>
                    </InfoPopUp> */}
                </>
            }
            value={`${formatUSD(userAccumulatedVoSpool || 0)} voSPOOL`}
        />
    );
};

export default AcccumulatedVoSpool;
